import React, { FunctionComponent } from 'react';
import { Select, SelectProps } from '../ui-kit';
import { FormField, FormFieldProps } from './form-field';

export const FormSelect: FunctionComponent<
  Omit<FormFieldProps, 'render' | 'placeholder'> & SelectProps
> = (formFieldProps) => {
  const fieldProps: SelectProps & { name: string } = {
    placeholder: formFieldProps.placeholder,
    mode: formFieldProps.mode,
    style: { width: '100%' },
    options: formFieldProps.options,
    showSearch: formFieldProps.showSearch,
    allowClear: formFieldProps.allowClear,
    loading: formFieldProps.loading,
    disabled: formFieldProps.disabled,
    size: formFieldProps.size || 'large',
    defaultValue: formFieldProps.defaultValue,
    filterOption: formFieldProps.filterOption,
    getPopupContainer: formFieldProps.getPopupContainer,
    popupClassName: formFieldProps.popupClassName,

    className: formFieldProps.className,
    name: formFieldProps.controllerProps?.name,
    'aria-label':
      formFieldProps['aria-label'] || formFieldProps.controllerProps?.name,
    onSelect: formFieldProps.onSelect,
  };

  return (
    <FormField
      {...formFieldProps}
      render={({ field }) => {
        return (
          <Select
            className="form-field__select"
            size={fieldProps.size}
            {...field}
            {...fieldProps}
            onChange={(val) => field.onChange(val ?? '')}
          />
        );
      }}
    />
  );
};
